module.exports = __webpack_public_path__ + "static/media/49.d411aa14.jpg";